export const ItemListJSONLD: (props: {
  urlList: string[];
  isCollectionPage?: boolean;
  mainUrl?: string;
}) => JSX.Element = (props) => {
  const { urlList = [], isCollectionPage = false, mainUrl = '' } = props;
  const itemList = urlList.map((url: string, index: number) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      url,
    };
  });
  const baseItemListJSONLD = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: itemList,
  };
  const itemListJSONLD = isCollectionPage
    ? {
        ...baseItemListJSONLD,
        mainEntityOfPage: {
          '@id': mainUrl,
          '@type': 'CollectionPage',
        },
        numberOfItems: itemList.length || 0,
      }
    : baseItemListJSONLD;
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(itemListJSONLD) }} />;
};
